export function buildIntercomTarget(segments: string[]): string {
  return segments.join('.').split(' ').join('-').toLowerCase();
}
